import type { ReactNode } from "react";
import { Box, Container } from "@mui/material";
import Header from "../Header";
import Navigation from "../Navigation";

type PageLayoutProps = {
  children: ReactNode;
  blocked?: boolean;
};

const PageLayout = ({ children, blocked = false }: PageLayoutProps) => {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Box className="content-wrapper" display="flex" flex={1} minHeight={0}>
        {!blocked && <Navigation />}
        <Box component="main" className="main-wrapper" flex={1} minWidth={0}>
          <Container>{children}</Container>
        </Box>
      </Box>
    </Box>
  );
};

export default PageLayout;
